var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "eol-available"
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "Btn__wrap"
  }, [_c('button', {
    staticClass: "Btn__disabled",
    on: {
      "click": _vm.clickShareLink
    }
  }, [_c('img', {
    attrs: {
      "src": require("./ic-kakao.png")
    }
  }), _vm._v(" 카카오톡으로 문의하기 ")])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "center-wrapper"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("./ic-logo.png")
    }
  }), _c('div', {
    staticClass: "head-text"
  }, [_vm._v("서비스 이용 불가 안내")]), _c('div', {
    staticClass: "description-text"
  }, [_vm._v(" 로그인 하신 계정은 2023년 9월 16일부로 종료된 이전 버전의 랩매니저에서 사용하시던 계정으로 확인됩니다. 종료된 서비스의 데이터를 이관하여 계속해서 사용을 원하신다면 아래 카카오톡 채널로 문의 해 주세요. ")])]);
}]

export { render, staticRenderFns }